import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { sizePage } from '../app.constants';

@Injectable({
  providedIn: 'root'
})
export class HistoryService {

  constructor(private readonly http: HttpClient) {
  }

  GetLogsTypeList(): Observable<any> {
    return this.http.get<any>('/binnacle/', { observe: 'response' });
  }

  public getHistoryList(pData: any, page: number): Observable<any> {
    page--;
    return this.http.get<any>('/client/binnacle/page/' + page.toString()
      + '?size=' + sizePage
      + '&' + pData,
      { observe: 'response' });
  }

  GetReportPDF(pData: any) {
    const url = "/client/binnacle/report/pdf/?" + pData;
    console.log("GetReportPDF", url);
    return this.http.get(url, { responseType: 'blob' })    
      .pipe(
        map((result: any) => {
          //console.log(result);
          return result;
        })
      );
  }

  GetReportExcel(pData: any) {
    const url = "/client/binnacle/report/xlsx/?" + pData;
    console.log("GetReportPDF", url);
    return this.http.get(url, { responseType: 'blob' })    
      .pipe(
        map((result: any) => {
          //console.log(result);
          return result;
        })
      );
  }

}
